<template>
  <div>
    <Form ref="dataForm" :model="dataForm">
      <FormItem prop="auditNote" >
        <Input type="textarea" :rows="4" placeholder="请输入，最多300字" :maxlength="300" v-model.trim="dataForm.auditNote" />
      </FormItem>
    </Form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataForm: {
        auditNote: ''
      }
    };
  },
  props: {
    approvalFlag: Boolean
  },
  watch: {
    approvalFlag(val) {
      if (val) {
        this.$refs.dataForm.resetFields();
      }
    }
  }
};
</script>

<style>

</style>
